export const FETCH_GRATUITY_RULES_ABOVE_N_YEAR_UN_LIMITEDS =
  "FETCH_GRATUITY_RULES_ABOVE_N_YEAR_UN_LIMITEDS";
export const EDIT_GRATUITY_RULES_ABOVE_N_YEAR_UN_LIMITED =
  "EDIT_GRATUITY_RULES_ABOVE_N_YEAR_UN_LIMITED";
